import { MultiSelect } from 'legacy/lut/library/multiSelect'
import { useCallback, useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import styles from '../QBRDocumentsFilterArea.module.scss'

interface IQBRsFYearMultiselectProps {
  qbrDocumentsData: IQBRDocumentsListItem[]
  fyearValue: string[]
  onChangeFyearValue: (value: string[]) => void
}

export const QBRsFYearMultiselect = ({
  qbrDocumentsData,
  fyearValue,
  onChangeFyearValue,
}: IQBRsFYearMultiselectProps) => {
  const fyearArray = qbrDocumentsData.map((values) => {
    return values.FYearQuarter
  })

  const crud = useMemo(() => {
    return new Crud({
      fetcher: new Static([...new Set(fyearArray)].map((el) => ({ value: el }))),
      defaultSort: { field: 'value', dir: 'asc' },
      keyField: 'value',
      defaultPaging: { page: 0, pageSize: fyearArray.length },
    })
  }, [fyearArray])

  const onFYearChange = useCallback(
    (value: string[]) => {
      onChangeFyearValue(value)
    },
    [onChangeFyearValue]
  )

  return (
    <div className={styles.filter}>
      <MultiSelect
        value={fyearValue}
        source={crud}
        label="FYear"
        caption={'value'}
        onChange={onFYearChange}
      />
    </div>
  )
}
